export const shopfloorMessages = {
  en: {
    shopfloor: {
      appTitle: 'Shopfloor',
      appDescription: 'Shift execution, worker and machine assignments, output, downtime, and handover.',
      nav: {
        shiftDashboard: 'Shift dashboard',
        activeOrders: 'Active orders',
        assignments: 'Assignments',
        hourlyOutput: 'Hourly output',
        knittingOutput: 'Daily knitting output',
        knittingKiosk: 'Knitting kiosk',
        downtime: 'Downtime',
        handover: 'Handover',
        help: 'Help',
      },
      help: {
        eyebrow: 'Help center',
        title: 'Help',
        subtitle: 'Step-by-step guides for every section.',
        back: 'Back to help',
        notFound: 'Article not found.',
        tipsTitle: 'Tips',
      },
      dashboard: {
        eyebrow: 'Manufacturing execution',
        title: 'Shift dashboard',
        description: 'Active production status, bottlenecks, and shift summary.',
        activeOrders: 'Active orders',
        ordersCount: '{count} orders',
        planVsActual: 'Plan vs actual',
        planned: 'Planned',
        produced: 'Produced',
        pairs: '{count} pairs',
        bottlenecks: 'Bottlenecks',
        noBottlenecks: 'No bottlenecks detected.',
        bottleneckHint: 'Select a bottleneck to open the order and inspect the blocked stage.',
        stageBlocked: '{stage} blocked',
        employeeSummary: 'Employee summary',
        assigned: '{count} assigned',
        machineSummary: 'Machine summary',
        running: '{count} running',
        idle: '{count} idle',
        loading: 'Loading shift data…',
        error: 'Failed to load shift data.',
        retry: 'Retry',
        completion: 'Completion',
        rejectsRework: 'Rejects & rework',
        rejectedPairs: '{count} rejected pairs · {rework} rework',
        employeeAssignment: 'Employee assignment',
        employeesAssigned: '{count} employees assigned to open stages',
      },
      orders: {
        eyebrow: 'Production orders',
        title: 'Active orders',
        description: 'Production orders currently in execution.',
        search: 'Search orders',
        searchPlaceholder: 'Order code, product, or department',
        status: 'Status',
        allStatuses: 'All statuses',
        inProgress: 'In progress',
        completed: 'Completed',
        pending: 'Pending',
        statuses: {
          planned: 'Planned',
          in_progress: 'In progress',
          completed: 'Completed',
          cancelled: 'Cancelled',
        },
        code: 'Order',
        product: 'Product',
        department: 'Department',
        plannedQty: 'Planned',
        producedQty: 'Produced',
        progress: 'Progress',
        stage: 'Stage',
        actions: 'Actions',
        loading: 'Loading orders…',
        empty: 'No production orders match the selected filters.',
        viewLots: 'View lots',
      },
      assignments: {
        eyebrow: 'Resource assignments',
        title: 'Employee & machine assignments',
        description: 'Current shift assignments for employees and machines.',
        employeeTab: 'Employees',
        machineTab: 'Machines',
        employee: 'Employee',
        machine: 'Machine',
        operation: 'Operation',
        order: 'Order',
        lot: 'Lot',
        assignedAt: 'Assigned at',
        status: 'Status',
        active: 'Active',
        loading: 'Loading assignments…',
        empty: 'No active assignments for the current shift.',
        unassigned: 'Unassigned',
        createAssignment: 'Create assignment',
        create: 'Create',
        creating: 'Creating…',
        end: 'End',
        endConfirm: 'End this assignment?',
        allShifts: 'All shifts',
        shift: 'Shift',
        day: 'Day',
        night: 'Night',
        type: 'Type',
        orderId: 'Order ID',
        stageCode: 'Stage code',
        stage: 'Stage',
        selectStage: 'Select stage',
        selectEmployee: 'Select employee',
        selectMachine: 'Select machine',
        noLot: 'No lot',
        cancel: 'Cancel',
        save: 'Save',
        ended: 'Ended',
        noEnded: 'Show active only',
      },
      output: {
        eyebrow: 'Production tracking',
        title: 'Daily output',
        description: 'Production counts by stage and employee for the selected date.',
        date: 'Date',
        stage: 'Stage',
        stageCode: 'Stage code',
        employee: 'Employee',
        allStages: 'All stages',
        allEmployees: 'All employees',
        completed: 'Completed',
        rejected: 'Rejected',
        rework: 'Rework',
        unassigned: 'Unassigned',
        exportCsv: 'Export CSV',
        loading: 'Loading output data…',
        empty: 'No output data recorded for this date.',
        retry: 'Retry',
      },
      knittingOutput: {
        eyebrow: 'Knitting stock posting',
        title: 'Daily knitting output',
        description: 'Post semi-finished knitting lots by model, color, size, shift, and warehouse.',
        header: 'Header',
        newOutput: 'New output',
        moreOptions: 'More options',
        back: 'Back',
        next: 'Next',
        rowsHint: 'Add one row for each colour and size you produced.',
        addRowTitle: 'New colour / size row',
        editRowTitle: 'Edit row',
        askColor: 'Which colour?',
        askSize: 'Which size?',
        askQuantity: 'How many pieces?',
        askLot: 'Lot number (optional)',
        askNotes: 'Comment (optional)',
        rowStepOf: 'Step {current} of {total}',
        editRow: 'Edit',
        cancel: 'Cancel',
        rowsEmpty: 'No rows yet. Add the first colour and size.',
        addFirstRow: 'Add first row',
        saveRow: 'Save row',
        close: 'Close',
        rows: 'Color and size rows',
        history: 'Today history',
        exportXlsx: 'Export XLSX',
        dateFrom: 'Date from',
        dateTo: 'Date to',
        dateRange: 'Date range',
        date: 'Date',
        shift: 'Shift',
        allShifts: 'All shifts',
        day: 'Day',
        night: 'Night',
        product: 'Model',
        allProducts: 'All models',
        warehouse: 'Semi-finished warehouse',
        allWarehouses: 'All warehouses',
        employee: 'Employee',
        machine: 'Machine',
        order: 'Production order',
        notes: 'Notes',
        optional: 'Optional',
        noOrder: 'No order',
        selectProduct: 'Select model',
        selectWarehouse: 'Select warehouse',
        color: 'Color',
        selectColor: 'Select color',
        pick: 'Pick',
        generate: 'Generate',
        colorPickerTitle: 'Select color',
        colorPickerEyebrow: 'Color repository',
        colorSearch: 'Search colors',
        colorSearchPlaceholder: 'Name or code',
        noColors: 'No matching colors found.',
        noColorCode: 'No code',
        colorPage: '{count} items · Page {page} of {total}',
        closeColorPicker: 'Close color picker',
        modelPickerTitle: 'Select model',
        modelPickerEyebrow: 'Model catalog',
        modelSearch: 'Search models',
        modelSearchPlaceholder: 'Name or SKU',
        noModels: 'No matching models found.',
        modelPage: '{count} items · Page {page} of {total}',
        closeModelPicker: 'Close model picker',
        modelLoading: 'Loading models...',
        clearModel: 'Clear model filter',
        size: 'Size',
        sizePlaceholder: 'Type or pick size',
        sizeSuggestions: 'Suggested size ranges',
        quantity: 'Quantity',
        lotNumber: 'Lot number',
        basket: 'Basket',
        lotWarehouse: 'Lot / warehouse',
        worker: 'Worker',
        rowNotes: 'Row notes',
        actions: 'Actions',
        search: 'Search',
        searchPlaceholder: 'Model, color, size or warehouse',
        perPage: 'Per page',
        showDeleted: 'Show deleted',
        applyFilters: 'Apply',
        status: 'Status',
        active: 'Active',
        deleted: 'Deleted',
        deleteBatch: 'Delete batch',
        deleting: 'Deleting...',
        deleteConfirm: 'Delete this production batch?',
        deleteSuccess: 'Production batch deleted.',
        pageOf: 'Page {page} of {total} · {count} rows',
        addRow: 'Add row',
        remove: 'Remove',
        totalQuantity: 'Total quantity',
        rowCount: 'Rows',
        pageTotal: 'Page total',
        filteredTotal: 'Filtered total',
        clear: 'Clear',
        submit: 'Post output',
        submitting: 'Posting...',
        validation: 'Select a model, semi-finished warehouse, and complete every row.',
        saved: '{count} knitting rows posted.',
        loading: 'Loading knitting output...',
        empty: 'No knitting output recorded for this date.',
      },
      orderDetail: {
        backToOrders: 'Back to orders',
        title: 'Production order',
        planned: 'Planned',
        produced: 'Produced',
        totalLots: 'Total lots',
        activeLots: 'Active lots',
        completedLots: 'Completed lots',
        stageProgress: 'Stage progress',
        cancel: 'Cancel',
        createLot: 'Create lot',
        creating: 'Creating…',
        startingStage: 'Starting stage',
        quantity: 'Quantity',
        notes: 'Notes',
        colorVariants: 'Color variants',
        addColor: 'Add color',
        removeColor: 'Remove',
        colorName: 'Color',
        colorQuantity: 'Qty',
        colorSummary: 'Colors',
        colorsSumHint: 'Sum {sum} of {quantity}',
        colorRequired: 'Enter a color name and a positive quantity for every row.',
        colorSumError: 'Color quantities must equal the lot quantity.',
        lotCreated: 'Lot {lot} created.',
        noStages: 'No stages configured for this order.',
        lotQueue: 'Lot queue',
        lotNumber: 'Lot number',
        allStatuses: 'All statuses',
        allStages: 'All stages',
        active: 'Active',
        completed: 'Completed',
        cancelled: 'Cancelled',
        lotStatuses: {
          active: 'Active',
          completed: 'Completed',
          cancelled: 'Cancelled',
        },
        stageStatuses: {
          pending: 'Pending',
          in_progress: 'In progress',
          closed: 'Closed',
          completed: 'Completed',
        },
        noLotsMatch: 'No lots match the selected filters.',
        lot: 'Lot',
        status: 'Status',
        currentStage: 'Current stage',
        initial: 'Initial',
        current: 'Current',
        created: 'Created',
        actions: 'Actions',
        progress: 'Progress',
        closeStage: 'Close stage',
        recordProgress: 'Record progress',
        stageLabel: 'Stage:',
        completedQty: 'Completed',
        rejected: 'Rejected',
        rework: 'Rework',
        employeeId: 'Employee ID',
        employee: 'Employee',
        unassigned: 'Unassigned',
        selectEmployeePlaceholder: 'Select employee',
        details: 'Details',
        viewEntries: 'Entries',
        reopenStage: 'Reopen',
        closeStageTitle: 'Close stage',
        closeStageHint: 'Closes this stage for the whole order (all lots).',
        confirm: 'Confirm',
        close: 'Close',
        reopenStageTitle: 'Reopen stage',
        reopenHint: 'Reopening requires a reason and supervisor permission.',
        reopenReason: 'Reason',
        selectReason: 'Select reason…',
        reopenReasonText: 'Reason details',
        reopenRequiresReason: 'Select a reason and enter details.',
        stageClosedAll: 'Stage {stage} closed for all lots.',
        stageReopened: 'Stage {stage} reopened.',
        entriesTitle: 'Stage entries',
        noEntries: 'No entries recorded for this stage.',
        entryAction: 'Action',
        entryDeltas: 'Deltas',
        entryEmployee: 'Employee',
        entryLot: 'Lot',
        entryTime: 'Time',
        entryStage: 'Stage',
        entryTypes: {
          progress: 'Progress',
          close: 'Close',
          reopen: 'Reopen',
          create: 'Create',
        },
        reopenReasons: {
          qc_issue: 'QC issue',
          operator_error: 'Operator error',
          material_issue: 'Material issue',
          machine_issue: 'Machine issue',
          supervisor_decision: 'Supervisor decision',
          other: 'Other',
        },
        lotDetailsTitle: 'Lot details',
        lotStages: 'Lot stage tracking',
        lotEntries: 'Lot activity',
        stage: 'Stage',
        save: 'Save',
        selectEmployee: 'Select the reporting employee.',
        selectClosingEmployee: 'Select the closing employee.',
        closeConfirm: 'Close stage {stage} for lot {lot}?',
        progressRecorded: 'Progress recorded for lot {lot}.',
        stageClosed: 'Stage closed for lot {lot}.',
        enterStageQuantity: 'Enter a starting stage and a quantity greater than zero.',
        loadingOrder: 'Loading order…',
        pageOf: 'Page {page} of {total}',
        previous: 'Previous',
        next: 'Next',
      },
      downtime: {
        eyebrow: 'Downtime tracking',
        title: 'Downtime events',
        description: 'Recorded downtime with reasons and durations.',
        reason: 'Reason',
        machine: 'Machine',
        noMachine: 'No machine',
        selectMachine: 'Select machine…',
        reasons: {
          machine_breakdown: 'Machine breakdown',
          setup_change: 'Setup / size change',
          yarn_shortage: 'Yarn shortage',
          power_outage: 'Power outage',
          no_assignment: 'No operator assigned',
          qc_wait: 'Waiting for QC',
        },
        start: 'Start',
        end: 'End',
        duration: 'Duration',
        minutes: '{count} min',
        reportedBy: 'Reported by',
        loading: 'Loading downtime events…',
        empty: 'No downtime events recorded.',
        totalDowntime: 'Total downtime',
        activeDowntime: 'Active downtime',
        noActiveDowntime: 'No active downtime events.',
        ongoing: 'Ongoing',
        openDowntime: 'Report downtime',
        close: 'Close',
        closeConfirm: 'Close this downtime event?',
        selectReason: 'Select reason',
        machineId: 'Machine ID',
        startTime: 'Start time',
        endTime: 'End time',
        report: 'Report',
        reporting: 'Reporting…',
        openOnly: 'Open only',
        reported: 'Reported downtime #{id}',
        closed: 'Downtime #{id} closed',
      },
      handover: {
        eyebrow: 'Shift management',
        title: 'Shift handover',
        description: 'Shift handover records and supervisor notes.',
        shift: 'Shift',
        from: 'From',
        to: 'To',
        supervisor: 'Supervisor',
        notes: 'Notes',
        summary: 'Summary',
        ordersHandedOver: 'Orders handed over',
        issuesFlagged: 'Issues flagged',
        loading: 'Loading handover records…',
        empty: 'No handover records for the selected period.',
        attentionRequired: 'Attention required',
        printSnapshot: 'Print snapshot',
        exportCsv: 'Export CSV',
        createHandover: 'Create handover',
        create: 'Create',
        creating: 'Creating…',
        save: 'Save',
        cancel: 'Cancel',
        created: 'Handover #{id} created',
      },
      knittingKiosk: {
        description: 'Card scan, basket output and batch sticker for the knitting stage.',
        stepScan: 'Scan your card to create new record',
        stepPick: 'Pick the production order',
        stepEnter: 'Enter the output quantity',
        stepEnterHint: 'Fill the colour and size cells, then press Save output.',
        stepSaved: 'Output saved — write the basket number on the sticker',
        stepSavedHint: 'Press “Return to orders” to create the next basket — the worker stays signed in.',
        resultDone: 'Done — scan the next card',
        resultBackToOrders: 'Return to orders',
        setupOpen: 'Terminal setup',
        backToShopfloor: 'Back to shopfloor',
        setupTitle: 'Terminal setup',
        setupDescription: 'Stored on this device only and configured once per kiosk.',
        stageCode: 'Stage codes',
        stageCodeHint: 'Leave empty to detect the stage codes of this terminal from the open production orders (recommended). Comma-separated values override the detection.',
        stageCodePlaceholder: 'Auto',
        stageDetected: 'Detected from open orders: {stages}',
        stageNone: 'nothing found yet',
        token: 'Terminal token',
        tokenHint: 'Device token of this kiosk. Card scans are authenticated with it and never with the operator login.',
        idleTimeout: 'Logout timer (seconds)',
        idleTimeoutHint: 'Inactivity before the worker is logged out ({min}–{max} s). The basket ticket never logs out by itself — it returns to the orders list.',
        warehouse: 'Destination warehouse',
        warehouseEmpty: 'No semi-finished warehouse found. Ask a supervisor to configure one.',
        close: 'Close',
        loginSubtitle: 'Hold your worker card in front of the reader — no need to tap the field first.',
        cardLabel: 'Card number',
        cardPlaceholder: 'Waiting for the card…',
        loginSubmit: 'Continue',
        loginChecking: 'Checking the card…',
        loginFailed: 'Card was not recognised. Try again or enter your employee code.',
        tokenRejected: 'The terminal token was rejected. Check it in the terminal setup, or enter the employee code.',
        codeLabel: 'Employee code',
        codePlaceholder: 'For example EMP-0012',
        codeSubmit: 'Continue',
        codeFailed: 'No active production employee matches that code.',
        codeToggle: 'No card? Enter the employee code',
        needPermission: 'Your account cannot record production output. Ask a supervisor.',
        shift: 'Shift',
        shiftDay: 'Day',
        shiftNight: 'Night',
        changeWorker: 'Change worker',
        sessionTimeout: 'Auto logout in {time}',
        fullscreenEnter: 'Full screen',
        fullscreenExit: 'Exit full screen',
        journal: 'Journal',
        journalTitle: 'Baskets — last 24 hours',
        journalSubtitle: 'Saved baskets, from every terminal.',
        journalMine: 'Mine',
        journalAll: 'All terminals',
        journalSummary: '{baskets} baskets · {quantity} pairs',
        journalEmpty: 'No baskets were saved in the last 24 hours.',
        journalOffline: 'Server unreachable — showing only the baskets this terminal saved.',
        journalTime: 'Time',
        journalProduct: 'Product',
        journalWorker: 'Worker',
        journalLines: 'Colour / size',
        journalStatus: 'Status',
        journalQuantity: 'Output',
        journalPage: '{count} baskets · Page {page} of {total}',
        journalClose: 'Close journal',
        productsSubtitle: 'Only products waiting at this stage are shown.',
        productsSearch: 'Search by product name',
        productsRefresh: 'Refresh',
        productsEmpty: 'Nothing is waiting at this stage right now.',
        productsEmptyHint: 'Stage codes: {stages}. A product appears here only when an open order still has remaining quantity at its first operation (colour/size matrix).',
        productsNoMatch: 'No product matches the search.',
        productsRemaining: 'Remaining',
        productsCells: '{count} colour/size',
        matrixSize: 'Size',
        matrixPlan: 'Plan',
        matrixLeft: 'Left',
        matrixScrollLeft: 'Scroll colours left',
        matrixScrollRight: 'Scroll colours right',
        matrixQuantity: 'Output',
        matrixClear: 'Clear',
        matrixTotal: 'Output total',
        matrixSave: 'Save output',
        matrixSaving: 'Saving…',
        matrixEmpty: 'Enter an output quantity first.',
        matrixMax: 'Only {max} pairs are left for this size.',
        numpadOpen: 'Number pad',
        numpadClose: 'Done',
        numpadBack: 'Backspace',
        matrixNoWarehouse: 'Destination warehouse is not configured. Open the terminal setup.',
        matrixNoColour: 'No colour',
        matrixNoSize: 'No size',
        back: 'Back',
        resultBasket: 'Basket number',
        resultQuantity: 'Output',
        resultPrint: 'Print sticker',
        pendingTitle: 'Waiting to be sent',
        pendingHint: '{count} output row(s) are still queued. They are kept on this device — retry when the network is back.',
        pendingRetry: 'Retry now',
        pendingCancel: 'Cancel this output',
        pendingCancelConfirm: 'Discard this unsent output? It is not recorded on the server and cannot be recovered.',
        pendingNeedsReview: 'Rejected by the server — retry after it is fixed, or cancel',
        pendingWaiting: 'Waiting to be sent',
        pendingRows: '{count} colour/size rows',
        pendingFailed: 'Some rows could not be saved',
      },
      pagination: {
        of: 'of',
        previous: 'Previous',
        next: 'Next',
      },
      state: {
        loading: 'Loading…',
        error: 'Something went wrong.',
        retry: 'Retry',
        noData: 'No data available.',
      },
    },
  },
  uz: {
    shopfloor: {
      appTitle: 'Ishlab chiqarish maydoni',
      appDescription: 'Smena boshqaruvi, ishchi va stanok taqsimoti, ishlab chiqarish, to‘xtalishlar va smena topshirish.',
      nav: {
        shiftDashboard: 'Smena paneli',
        activeOrders: 'Faol buyurtmalar',
        assignments: 'Taqsimotlar',
        hourlyOutput: 'Soatlik ishlab chiqarish',
        knittingOutput: 'Kunlik to‘qish chiqimi',
        knittingKiosk: 'To‘qish kioski',
        downtime: 'To‘xtalishlar',
        handover: 'Smena topshirish',
        help: 'Yordam',
      },
      help: {
        eyebrow: 'Yordam markazi',
        title: 'Yordam',
        subtitle: 'Har bir bo‘lim uchun bosqichma-bosqich qo‘llanmalar.',
        back: 'Yordamga qaytish',
        notFound: 'Maqola topilmadi.',
        tipsTitle: 'Maslahatlar',
      },
      dashboard: {
        eyebrow: 'Ishlab chiqarish boshqaruvi',
        title: 'Smena paneli',
        description: 'Faol ishlab chiqarish holati, muammolar va smena xulosasi.',
        activeOrders: 'Faol buyurtmalar',
        ordersCount: '{count} ta buyurtma',
        planVsActual: 'Reja va amal',
        planned: 'Reja',
        produced: 'Ishlab chiqarilgan',
        pairs: '{count} juft',
        bottlenecks: 'To‘siqlar',
        noBottlenecks: 'To‘siqlar aniqlanmadi.',
        bottleneckHint: 'To‘siqni tanlang — buyurtma ochilib, to‘silgan bosqich ko‘rsatiladi.',
        stageBlocked: '{stage} to‘sildi',
        employeeSummary: 'Xodimlar xulosasi',
        assigned: '{count} ta tayinlangan',
        machineSummary: 'Stanoklar xulosasi',
        running: '{count} ta ishlamoqda',
        idle: '{count} ta bo‘sh',
        loading: 'Smena ma’lumotlari yuklanmoqda…',
        error: 'Smena ma’lumotlarini yuklab bo‘lmadi.',
        retry: 'Qayta urinish',
        completion: 'Bajarilish',
        rejectsRework: 'Rad va qayta ishlash',
        rejectedPairs: '{count} rad etilgan juft · {rework} qayta ishlash',
        employeeAssignment: 'Xodimlar taqsimoti',
        employeesAssigned: '{count} ta xodim ochiq bosqichlarga tayinlangan',
      },
      orders: {
        eyebrow: 'Ishlab chiqarish buyurtmalari',
        title: 'Faol buyurtmalar',
        description: 'Hozirda bajarilayotgan ishlab chiqarish buyurtmalari.',
        search: 'Buyurtmalarni qidirish',
        searchPlaceholder: 'Buyurtma kodi, mahsulot yoki bo‘lim',
        status: 'Holat',
        allStatuses: 'Barcha holatlar',
        inProgress: 'Jarayonda',
        completed: 'Yakunlangan',
        pending: 'Kutilmoqda',
        statuses: {
          planned: 'Rejalashtirilgan',
          in_progress: 'Jarayonda',
          completed: 'Yakunlangan',
          cancelled: 'Bekor qilingan',
        },
        code: 'Buyurtma',
        product: 'Mahsulot',
        department: 'Bo‘lim',
        plannedQty: 'Reja',
        producedQty: 'Ishlab chiqarilgan',
        progress: 'Bajarilish',
        stage: 'Bosqich',
        actions: 'Amallar',
        loading: 'Buyurtmalar yuklanmoqda…',
        empty: 'Tanlangan filtrlarga mos buyurtmalar mavjud emas.',
        viewLots: 'Partiyalarni ko‘rish',
      },
      assignments: {
        eyebrow: 'Resurs taqsimoti',
        title: 'Xodim va stanok taqsimoti',
        description: 'Joriy smena uchun xodim va stanok taqsimotlari.',
        employeeTab: 'Xodimlar',
        machineTab: 'Stanoklar',
        employee: 'Xodim',
        machine: 'Stanok',
        operation: 'Operatsiya',
        order: 'Buyurtma',
        lot: 'Partiya',
        assignedAt: 'Tayinlangan vaqt',
        status: 'Holat',
        active: 'Faol',
        loading: 'Taqsimotlar yuklanmoqda…',
        empty: 'Joriy smena uchun faol taqsimotlar mavjud emas.',
        unassigned: 'Tayinlanmagan',
        createAssignment: 'Taqsimot yaratish',
        create: 'Yaratish',
        creating: 'Yaratilmoqda…',
        end: 'Yakunlash',
        endConfirm: 'Ushbu taqsimotni yakunlash kerakmi?',
        allShifts: 'Barcha smenalar',
        shift: 'Smena',
        day: 'Kunduzgi',
        night: 'Tungi',
        type: 'Tur',
        orderId: 'Buyurtma ID',
        stageCode: 'Bosqich kodi',
        stage: 'Bosqich',
        selectStage: 'Bosqichni tanlang',
        selectEmployee: 'Xodimni tanlang',
        selectMachine: 'Stanokni tanlang',
        noLot: 'Partiyasiz',
        cancel: 'Bekor qilish',
        save: 'Saqlash',
        ended: 'Yakunlangan',
        noEnded: 'Faqat faollari',
      },
      output: {
        eyebrow: 'Ishlab chiqarish kuzatuvi',
        title: 'Kunlik ishlab chiqarish',
        description: 'Tanlangan sana bo‘yicha bosqichlar va xodimlar kesimida ishlab chiqarish miqdorlari.',
        date: 'Sana',
        stage: 'Bosqich',
        stageCode: 'Bosqich kodi',
        employee: 'Xodim',
        allStages: 'Barcha bosqichlar',
        allEmployees: 'Barcha xodimlar',
        completed: 'Bajarilgan',
        rejected: 'Rad etilgan',
        rework: 'Qayta ishlash',
        unassigned: 'Tayinlanmagan',
        exportCsv: 'CSV eksport',
        loading: 'Ishlab chiqarish ma’lumotlari yuklanmoqda…',
        empty: 'Ushbu sana uchun ishlab chiqarish ma’lumotlari mavjud emas.',
        retry: 'Qayta urinish',
      },
      knittingOutput: {
        eyebrow: 'To‘qish ombor kirimi',
        title: 'Kunlik to‘qish chiqimi',
        description: 'Yarim tayyor to‘qish partiyalarini model, rang, o‘lcham, smena va ombor bo‘yicha kirim qiling.',
        header: 'Sarlavha',
        newOutput: 'Yangi chiqim',
        moreOptions: 'Qo‘shimcha parametrlar',
        back: 'Orqaga',
        next: 'Keyingi',
        rowsHint: 'Ishlab chiqargan har bir rang va o‘lcham uchun bitta qator qo‘shing.',
        addRowTitle: 'Yangi rang / o‘lcham qatori',
        editRowTitle: 'Qatorni tahrirlash',
        askColor: 'Qaysi rang?',
        askSize: 'Qaysi o‘lcham?',
        askQuantity: 'Necha juft?',
        askLot: 'Partiya raqami (ixtiyoriy)',
        askNotes: 'Izoh (ixtiyoriy)',
        rowStepOf: '{total} qadamdan {current}-si',
        editRow: 'Tahrirlash',
        cancel: 'Bekor qilish',
        rowsEmpty: 'Hozircha qator yo‘q. Birinchi rang va o‘lchamni qo‘shing.',
        addFirstRow: 'Birinchi qatorni qo‘shish',
        saveRow: 'Qatorni saqlash',
        close: 'Yopish',
        rows: 'Rang va o‘lcham qatorlari',
        history: 'Bugungi tarix',
        exportXlsx: 'XLSX eksport',
        dateFrom: 'Boshlanish sanasi',
        dateTo: 'Tugash sanasi',
        dateRange: 'Sana oralig‘i',
        date: 'Sana',
        shift: 'Smena',
        allShifts: 'Barcha smenalar',
        day: 'Kunduzgi',
        night: 'Tungi',
        product: 'Model',
        allProducts: 'Barcha modellar',
        warehouse: 'Yarim tayyor ombor',
        allWarehouses: 'Barcha omborlar',
        employee: 'Xodim',
        machine: 'Stanok',
        order: 'Ishlab chiqarish buyurtmasi',
        notes: 'Izohlar',
        optional: 'Ixtiyoriy',
        noOrder: 'Buyurtmasiz',
        selectProduct: 'Modelni tanlang',
        selectWarehouse: 'Omborni tanlang',
        color: 'Rang',
        selectColor: 'Rangni tanlang',
        pick: 'Tanlash',
        generate: 'Yaratish',
        colorPickerTitle: 'Rangni tanlang',
        colorPickerEyebrow: 'Ranglar ma’lumotnomasi',
        colorSearch: 'Ranglarni qidirish',
        colorSearchPlaceholder: 'Nomi yoki kodi',
        noColors: 'Mos rang topilmadi.',
        noColorCode: 'Kod yo‘q',
        colorPage: '{count} ta · {page}/{total}-sahifa',
        closeColorPicker: 'Rang tanlashni yopish',
        modelPickerTitle: 'Modelni tanlang',
        modelPickerEyebrow: 'Modellar ma’lumotnomasi',
        modelSearch: 'Modellarni qidirish',
        modelSearchPlaceholder: 'Nomi yoki SKU',
        noModels: 'Mos model topilmadi.',
        modelPage: '{count} ta · {page}/{total}-sahifa',
        closeModelPicker: 'Model tanlashni yopish',
        modelLoading: 'Modellar yuklanmoqda...',
        clearModel: 'Model filtrini tozalash',
        size: 'O‘lcham',
        sizePlaceholder: 'Yozing yoki tanlang',
        sizeSuggestions: 'Tavsiya qilingan o‘lchamlar',
        quantity: 'Miqdor',
        lotNumber: 'Partiya raqami',
        basket: 'Savat',
        lotWarehouse: 'Partiya / ombor',
        worker: 'Ishchi',
        rowNotes: 'Qator izohi',
        actions: 'Amallar',
        search: 'Qidirish',
        searchPlaceholder: 'Model, rang, o‘lcham yoki ombor',
        perPage: 'Sahifada',
        showDeleted: 'O‘chirilganlarni ko‘rsatish',
        applyFilters: 'Qo‘llash',
        status: 'Holat',
        active: 'Faol',
        deleted: 'O‘chirilgan',
        deleteBatch: 'Partiyani o‘chirish',
        deleting: 'O‘chirilmoqda...',
        deleteConfirm: 'Ushbu ishlab chiqarish partiyasi o‘chirilsinmi?',
        deleteSuccess: 'Ishlab chiqarish partiyasi o‘chirildi.',
        pageOf: '{page}/{total}-sahifa · {count} qator',
        addRow: 'Qator qo‘shish',
        remove: 'O‘chirish',
        totalQuantity: 'Jami miqdor',
        rowCount: 'Qatorlar',
        pageTotal: 'Sahifa jami',
        filteredTotal: 'Filtr bo‘yicha jami',
        clear: 'Tozalash',
        submit: 'Chiqimni saqlash',
        submitting: 'Saqlanmoqda...',
        validation: 'Model, yarim tayyor omborni tanlang va har bir qatorni to‘ldiring.',
        saved: '{count} ta to‘qish qatori saqlandi.',
        loading: 'To‘qish chiqimi yuklanmoqda...',
        empty: 'Bu sana uchun to‘qish chiqimi yo‘q.',
      },
      orderDetail: {
        backToOrders: 'Buyurtmalarga qaytish',
        title: 'Ishlab chiqarish buyurtmasi',
        planned: 'Reja',
        produced: 'Ishlab chiqarilgan',
        totalLots: 'Jami partiyalar',
        activeLots: 'Faol partiyalar',
        completedLots: 'Yakunlangan partiyalar',
        stageProgress: 'Bosqichlar bajarilishi',
        cancel: 'Bekor qilish',
        createLot: 'Partiya yaratish',
        creating: 'Yaratilmoqda…',
        startingStage: 'Boshlang‘ich bosqich',
        quantity: 'Miqdor',
        notes: 'Izohlar',
        colorVariants: 'Rang variantlari',
        addColor: 'Rang qo‘shish',
        removeColor: 'O‘chirish',
        colorName: 'Rang',
        colorQuantity: 'Soni',
        colorSummary: 'Ranglar',
        colorsSumHint: '{quantity} dan {sum} yig‘indi',
        colorRequired: 'Har bir qator uchun rang nomi va noldan katta son kiriting.',
        colorSumError: 'Ranglar soni partiya miqdoriga teng bo‘lishi kerak.',
        lotCreated: '{lot} partiyasi yaratildi.',
        noStages: 'Ushbu buyurtma uchun bosqichlar sozlanmagan.',
        lotQueue: 'Partiyalar navbati',
        lotNumber: 'Partiya raqami',
        allStatuses: 'Barcha holatlar',
        allStages: 'Barcha bosqichlar',
        active: 'Faol',
        completed: 'Yakunlangan',
        cancelled: 'Bekor qilingan',
        lotStatuses: {
          active: 'Faol',
          completed: 'Yakunlangan',
          cancelled: 'Bekor qilingan',
        },
        stageStatuses: {
          pending: 'Kutilmoqda',
          in_progress: 'Jarayonda',
          closed: 'Yopilgan',
          completed: 'Yakunlangan',
        },
        noLotsMatch: 'Tanlangan filtrlarga mos partiyalar mavjud emas.',
        lot: 'Partiya',
        status: 'Holat',
        currentStage: 'Joriy bosqich',
        initial: 'Boshlang‘ich',
        current: 'Joriy',
        created: 'Yaratilgan',
        actions: 'Amallar',
        progress: 'Bajarilish',
        closeStage: 'Bosqichni yopish',
        recordProgress: 'Bajarilishni qayd etish',
        stageLabel: 'Bosqich:',
        completedQty: 'Bajarilgan',
        rejected: 'Rad etilgan',
        rework: 'Qayta ishlash',
        employeeId: 'Xodim ID',
        employee: 'Xodim',
        unassigned: 'Tayinlanmagan',
        selectEmployeePlaceholder: 'Xodimni tanlang',
        details: 'Tafsilotlar',
        viewEntries: 'Yozuvlar',
        reopenStage: 'Qayta ochish',
        closeStageTitle: 'Bosqichni yopish',
        closeStageHint: 'Bu bosqich butun buyurtma bo‘yicha (barcha partiyalar) yopiladi.',
        confirm: 'Tasdiqlash',
        close: 'Yopish',
        reopenStageTitle: 'Bosqichni qayta ochish',
        reopenHint: 'Qayta ochish sabab va rahbar ruxsatini talab qiladi.',
        reopenReason: 'Sabab',
        selectReason: 'Sababni tanlang…',
        reopenReasonText: 'Sabab tafsiloti',
        reopenRequiresReason: 'Sababni tanlang va tafsilotni kiriting.',
        stageClosedAll: '{stage} bosqichi barcha partiyalar uchun yopildi.',
        stageReopened: '{stage} bosqichi qayta ochildi.',
        entriesTitle: 'Bosqich yozuvlari',
        noEntries: 'Ushbu bosqich uchun yozuvlar mavjud emas.',
        entryAction: 'Harakat',
        entryDeltas: 'O‘zgarishlar',
        entryEmployee: 'Xodim',
        entryLot: 'Partiya',
        entryTime: 'Vaqt',
        entryStage: 'Bosqich',
        entryTypes: {
          progress: 'Bajarilish',
          close: 'Yopish',
          reopen: 'Qayta ochish',
          create: 'Yaratish',
        },
        reopenReasons: {
          qc_issue: 'Sifat nazorati muammosi',
          operator_error: 'Operator xatosi',
          material_issue: 'Material muammosi',
          machine_issue: 'Stanok muammosi',
          supervisor_decision: 'Rahbar qarori',
          other: 'Boshqa',
        },
        lotDetailsTitle: 'Partiya tafsilotlari',
        lotStages: 'Partiya bosqichlari kuzatuvi',
        lotEntries: 'Partiya faoliyati',
        stage: 'Bosqich',
        save: 'Saqlash',
        selectEmployee: 'Hisobot beruvchi xodimni tanlang.',
        selectClosingEmployee: 'Yopuvchi xodimni tanlang.',
        closeConfirm: '{lot} partiyasi uchun {stage} bosqichini yopish kerakmi?',
        progressRecorded: '{lot} partiyasi uchun bajarilish qayd etildi.',
        stageClosed: '{lot} partiyasi uchun bosqich yopildi.',
        enterStageQuantity: 'Boshlang‘ich bosqich va noldan katta miqdorni kiriting.',
        loadingOrder: 'Buyurtma yuklanmoqda…',
        pageOf: '{total} dan {page}-sahifa',
        previous: 'Oldingi',
        next: 'Keyingi',
      },
      downtime: {
        eyebrow: 'To‘xtalishlar kuzatuvi',
        title: 'To‘xtalish hodisalari',
        description: 'Sabablari va davomiyligi bilan qayd etilgan to‘xtalishlar.',
        reason: 'Sabab',
        machine: 'Stanok',
        noMachine: 'Stanok yo‘q',
        selectMachine: 'Stanokni tanlang…',
        reasons: {
          machine_breakdown: 'Stanok buzilishi',
          setup_change: 'Sozlash / o‘lcham almashtirish',
          yarn_shortage: 'Ip yetishmasligi',
          power_outage: 'Elektr uzilishi',
          no_assignment: 'Operator tayinlanmagan',
          qc_wait: 'Sifat nazoratini kutish',
        },
        start: 'Boshlanish',
        end: 'Tugash',
        duration: 'Davomiylik',
        minutes: '{count} daq',
        reportedBy: 'Xabar bergan',
        loading: 'To‘xtalish hodisalari yuklanmoqda…',
        empty: 'To‘xtalish hodisalari qayd etilmagan.',
        totalDowntime: 'Jami to‘xtalish',
        activeDowntime: 'Faol to‘xtalish',
        noActiveDowntime: 'Faol to‘xtalish hodisalari mavjud emas.',
        ongoing: 'Davom etmoqda',
        openDowntime: 'To‘xtalishni qayd etish',
        close: 'Yopish',
        closeConfirm: 'Ushbu to‘xtalish hodisasini yopish kerakmi?',
        selectReason: 'Sababni tanlang',
        machineId: 'Stanok ID',
        startTime: 'Boshlanish vaqti',
        endTime: 'Tugash vaqti',
        report: 'Qayd etish',
        reporting: 'Qayd etilmoqda…',
        openOnly: 'Faqat faollari',
        reported: '#{id} to‘xtalish qayd etildi',
        closed: '#{id} to‘xtalish yopildi',
      },
      handover: {
        eyebrow: 'Smena boshqaruvi',
        title: 'Smena topshirish',
        description: 'Smena topshirish yozuvlari va nazoratchi izohlari.',
        shift: 'Smena',
        from: 'Dan',
        to: 'Gacha',
        supervisor: 'Nazoratchi',
        notes: 'Izohlar',
        summary: 'Xulosa',
        ordersHandedOver: 'Topshirilgan buyurtmalar',
        issuesFlagged: 'Belgilangan muammolar',
        loading: 'Topshirish yozuvlari yuklanmoqda…',
        empty: 'Tanlangan davr uchun topshirish yozuvlari mavjud emas.',
        attentionRequired: 'E’tibor talab etiladi',
        printSnapshot: 'Xulosani chop etish',
        exportCsv: 'CSV eksport',
        createHandover: 'Smena topshirishni yaratish',
        create: 'Yaratish',
        creating: 'Yaratilmoqda…',
        save: 'Saqlash',
        cancel: 'Bekor qilish',
        created: '#{id} topshirish yaratildi',
      },
      knittingKiosk: {
        description: 'Karta skanerlash, savat chiqimi va to‘qish bosqichi uchun partiya yorlig‘i.',
        stepScan: 'Yangi yozuv yaratish uchun kartangizni skanerlang',
        stepPick: 'Ishlab chiqarish buyurtmasini tanlang',
        stepEnter: 'Chiqim miqdorini kiriting',
        stepEnterHint: 'Rang va o‘lcham kataklarini to‘ldirib, «Chiqimni saqlash» tugmasini bosing.',
        stepSaved: 'Chiqim saqlandi — savat raqamini yorliqqa yozing',
        stepSavedHint: 'Keyingi savatni yaratish uchun «Buyurtmalarga qaytish» tugmasini bosing — ishchi tizimdan chiqmaydi.',
        resultDone: 'Tayyor — keyingi kartani skanerlang',
        resultBackToOrders: 'Buyurtmalarga qaytish',
        setupOpen: 'Terminal sozlamalari',
        backToShopfloor: 'Ishlab chiqarish maydoniga qaytish',
        setupTitle: 'Terminal sozlamalari',
        setupDescription: 'Faqat shu qurilmada saqlanadi va kiosk uchun bir marta sozlanadi.',
        stageCode: 'Bosqich kodlari',
        stageCodeHint: 'Bo‘sh qoldirilsa, bu terminalning bosqich kodlari ochiq ishlab chiqarish buyurtmalaridan aniqlanadi (tavsiya etiladi). Vergul bilan kiritilgan kodlar aniqlashni almashtiradi.',
        stageCodePlaceholder: 'Avtomatik',
        stageDetected: 'Ochiq buyurtmalardan aniqlandi: {stages}',
        stageNone: 'hozircha topilmadi',
        token: 'Terminal tokeni',
        tokenHint: 'Shu kiosk qurilmasining tokeni. Karta skanerlash shu token bilan tasdiqlanadi, operator sessiyasi bilan emas.',
        idleTimeout: 'Avtomatik chiqish taymeri (soniya)',
        idleTimeoutHint: 'Ishchi avtomatik chiqarilishidan oldingi harakatsizlik ({min}–{max} s). Savat yorlig‘i o‘zi chiqarmaydi — buyurtmalar ro‘yxatiga qaytadi.',
        warehouse: 'Qabul qiluvchi ombor',
        warehouseEmpty: 'Yarim tayyor ombor topilmadi. Rahbardan sozlashni so‘rang.',
        close: 'Yopish',
        loginSubtitle: 'Ishchi kartangizni o‘quvchi oldiga tuting — maydonni bosish shart emas.',
        cardLabel: 'Karta raqami',
        cardPlaceholder: 'Karta kutilmoqda…',
        loginSubmit: 'Davom etish',
        loginChecking: 'Karta tekshirilmoqda…',
        loginFailed: 'Karta tanilmadi. Qayta urinib ko‘ring yoki xodim kodini kiriting.',
        tokenRejected: 'Terminal tokeni rad etildi. Uni terminal sozlamalarida tekshiring yoki xodim kodini kiriting.',
        codeLabel: 'Xodim kodi',
        codePlaceholder: 'Masalan EMP-0012',
        codeSubmit: 'Davom etish',
        codeFailed: 'Bu kodga mos faol ishlab chiqarish xodimi topilmadi.',
        codeToggle: 'Karta yo‘qmi? Xodim kodini kiriting',
        needPermission: 'Sizning hisobingiz ishlab chiqarish chiqimini kirita olmaydi. Rahbardan so‘rang.',
        shift: 'Smena',
        shiftDay: 'Kunduzgi',
        shiftNight: 'Tungi',
        changeWorker: 'Ishchini almashtirish',
        sessionTimeout: 'Avtomatik chiqish: {time}',
        fullscreenEnter: 'To‘liq ekran',
        fullscreenExit: 'To‘liq ekrandan chiqish',
        journal: 'Jurnal',
        journalTitle: 'Savatlar — oxirgi 24 soat',
        journalSubtitle: 'Saqlangan savatlar — barcha terminallardan.',
        journalMine: 'Mening savatlarim',
        journalAll: 'Barcha terminallar',
        journalSummary: '{baskets} savat · {quantity} juft',
        journalEmpty: 'Oxirgi 24 soatda savat saqlanmagan.',
        journalOffline: 'Serverga ulanmadi — faqat shu terminal saqlagan savatlar ko‘rsatiladi.',
        journalTime: 'Vaqt',
        journalProduct: 'Mahsulot',
        journalWorker: 'Ishchi',
        journalLines: 'Rang / o‘lcham',
        journalStatus: 'Holat',
        journalQuantity: 'Chiqim',
        journalPage: '{count} savat · {page} / {total} bet',
        journalClose: 'Jurnalni yopish',
        productsSubtitle: 'Faqat shu bosqichda kutayotgan mahsulotlar ko‘rsatiladi.',
        productsSearch: 'Mahsulot nomi bo‘yicha qidirish',
        productsRefresh: 'Yangilash',
        productsEmpty: 'Hozir bu bosqichda kutayotgan ish yo‘q.',
        productsEmptyHint: 'Bosqich kodlari: {stages}. Mahsulot faqat ochiq buyurtmaning birinchi operatsiyasida rang/o‘lcham matritsasida qoldiq bo‘lsa ko‘rinadi.',
        productsNoMatch: 'Qidiruvga mos mahsulot topilmadi.',
        productsRemaining: 'Qoldiq',
        productsCells: '{count} rang/o‘lcham',
        matrixSize: 'O‘lcham',
        matrixPlan: 'Reja',
        matrixLeft: 'Qoldiq',
        matrixScrollLeft: 'Ranglarni chapga surish',
        matrixScrollRight: 'Ranglarni o‘ngga surish',
        matrixQuantity: 'Chiqim',
        matrixClear: 'Tozalash',
        matrixTotal: 'Jami chiqim',
        matrixSave: 'Chiqimni saqlash',
        matrixSaving: 'Saqlanmoqda…',
        matrixEmpty: 'Avval chiqim miqdorini kiriting.',
        matrixMax: 'Bu o‘lcham uchun faqat {max} juft qoldi.',
        numpadOpen: 'Raqamlar klaviaturasi',
        numpadClose: 'Tayyor',
        numpadBack: 'O‘chirish',
        matrixNoWarehouse: 'Qabul qiluvchi ombor sozlanmagan. Terminal sozlamalarini oching.',
        matrixNoColour: 'Rangsiz',
        matrixNoSize: 'O‘lchamsiz',
        back: 'Orqaga',
        resultBasket: 'Savat raqami',
        resultQuantity: 'Chiqim',
        resultPrint: 'Yorliqni chop etish',
        pendingTitle: 'Yuborilmagan chiqimlar',
        pendingHint: '{count} chiqim yozuvi navbatda turibdi. Ular shu qurilmada saqlanadi — internet tiklanganda qayta urinib ko‘ring.',
        pendingRetry: 'Qayta urinish',
        pendingCancel: 'Bu chiqimni bekor qilish',
        pendingCancelConfirm: 'Yuborilmagan bu chiqimni o‘chiribsizmi? U serverda saqlanmagan va qaytarib bo‘lmaydi.',
        pendingNeedsReview: 'Server rad etdi — tuzatgach qayta yuboring yoki bekor qiling',
        pendingWaiting: 'Yuborilishi kutilmoqda',
        pendingRows: '{count} rang/o‘lcham qatori',
        pendingFailed: 'Ba’zi yozuvlarni saqlab bo‘lmadi',
      },
      pagination: {
        of: 'dan',
        previous: 'Oldingi',
        next: 'Keyingi',
      },
      state: {
        loading: 'Yuklanmoqda…',
        error: 'Xatolik yuz berdi.',
        retry: 'Qayta urinish',
        noData: 'Ma’lumot mavjud emas.',
      },
    },
  },
  ru: {
    shopfloor: {
      appTitle: 'Производственный цех',
      appDescription: 'Управление сменами, распределение сотрудников и оборудования, выработка, простои и передача смен.',
      nav: {
        shiftDashboard: 'Панель смены',
        activeOrders: 'Активные заказы',
        assignments: 'Назначения',
        hourlyOutput: 'Почасовая выработка',
        knittingOutput: 'Дневная выработка вязки',
        knittingKiosk: 'Киоск вязки',
        downtime: 'Простои',
        handover: 'Передача смены',
        help: 'Помощь',
      },
      help: {
        eyebrow: 'Центр помощи',
        title: 'Помощь',
        subtitle: 'Пошаговые руководства для каждого раздела.',
        back: 'Назад к помощи',
        notFound: 'Статья не найдена.',
        tipsTitle: 'Советы',
      },
      dashboard: {
        eyebrow: 'Управление производством',
        title: 'Панель смены',
        description: 'Текущий статус производства, узкие места и сводка смены.',
        activeOrders: 'Активные заказы',
        ordersCount: '{count} заказов',
        planVsActual: 'План и факт',
        planned: 'План',
        produced: 'Произведено',
        pairs: '{count} пар',
        bottlenecks: 'Узкие места',
        noBottlenecks: 'Узких мест не обнаружено.',
        bottleneckHint: 'Выберите узкое место, чтобы открыть заказ и просмотреть заблокированный этап.',
        stageBlocked: '{stage} заблокирован',
        employeeSummary: 'Сводка по сотрудникам',
        assigned: '{count} назначено',
        machineSummary: 'Сводка по оборудованию',
        running: '{count} работает',
        idle: '{count} простаивает',
        loading: 'Загрузка данных смены…',
        error: 'Не удалось загрузить данные смены.',
        retry: 'Повторить',
        completion: 'Завершение',
        rejectsRework: 'Брак и переработка',
        rejectedPairs: '{count} бракованных пар · {rework} переработка',
        employeeAssignment: 'Назначение сотрудников',
        employeesAssigned: '{count} сотрудников назначено на открытые этапы',
      },
      orders: {
        eyebrow: 'Производственные заказы',
        title: 'Активные заказы',
        description: 'Производственные заказы, находящиеся в исполнении.',
        search: 'Поиск заказов',
        searchPlaceholder: 'Код заказа, продукт или отдел',
        status: 'Статус',
        allStatuses: 'Все статусы',
        inProgress: 'В работе',
        completed: 'Завершён',
        pending: 'Ожидает',
        statuses: {
          planned: 'Запланирован',
          in_progress: 'В работе',
          completed: 'Завершён',
          cancelled: 'Отменён',
        },
        code: 'Заказ',
        product: 'Продукт',
        department: 'Отдел',
        plannedQty: 'План',
        producedQty: 'Произведено',
        progress: 'Прогресс',
        stage: 'Этап',
        actions: 'Действия',
        loading: 'Загрузка заказов…',
        empty: 'Нет заказов, соответствующих фильтрам.',
        viewLots: 'Просмотр партий',
      },
      assignments: {
        eyebrow: 'Распределение ресурсов',
        title: 'Назначения сотрудников и оборудования',
        description: 'Текущие назначения сотрудников и машин на смену.',
        employeeTab: 'Сотрудники',
        machineTab: 'Оборудование',
        employee: 'Сотрудник',
        machine: 'Машина',
        operation: 'Операция',
        order: 'Заказ',
        lot: 'Партия',
        assignedAt: 'Назначено',
        status: 'Статус',
        active: 'Активен',
        loading: 'Загрузка назначений…',
        empty: 'Нет активных назначений на текущую смену.',
        unassigned: 'Не назначен',
        createAssignment: 'Создать назначение',
        create: 'Создать',
        creating: 'Создание…',
        end: 'Завершить',
        endConfirm: 'Завершить это назначение?',
        allShifts: 'Все смены',
        shift: 'Смена',
        day: 'Дневная',
        night: 'Ночная',
        type: 'Тип',
        orderId: 'ID заказа',
        stageCode: 'Код этапа',
        stage: 'Этап',
        selectStage: 'Выберите этап',
        selectEmployee: 'Выберите сотрудника',
        selectMachine: 'Выберите машину',
        noLot: 'Без партии',
        cancel: 'Отмена',
        save: 'Сохранить',
        ended: 'Завершено',
        noEnded: 'Только активные',
      },
      output: {
        eyebrow: 'Учёт выработки',
        title: 'Дневная выработка',
        description: 'Показатели производства по этапам и сотрудникам за выбранную дату.',
        date: 'Дата',
        stage: 'Этап',
        stageCode: 'Код этапа',
        employee: 'Сотрудник',
        allStages: 'Все этапы',
        allEmployees: 'Все сотрудники',
        completed: 'Выполнено',
        rejected: 'Брак',
        rework: 'Переработка',
        unassigned: 'Не назначен',
        exportCsv: 'Экспорт CSV',
        loading: 'Загрузка данных выработки…',
        empty: 'Нет данных о выработке за эту дату.',
        retry: 'Повторить',
      },
      knittingOutput: {
        eyebrow: 'Оприходование вязки',
        title: 'Дневная выработка вязки',
        description: 'Оприходуйте полуфабрикаты вязки по модели, цвету, размеру, смене и складу.',
        header: 'Шапка',
        newOutput: 'Новая выработка',
        moreOptions: 'Дополнительно',
        back: 'Назад',
        next: 'Далее',
        rowsHint: 'Добавьте по одной строке для каждого цвета и размера.',
        addRowTitle: 'Новая строка цвета / размера',
        editRowTitle: 'Изменить строку',
        askColor: 'Какой цвет?',
        askSize: 'Какой размер?',
        askQuantity: 'Сколько штук?',
        askLot: 'Номер партии (необязательно)',
        askNotes: 'Комментарий (необязательно)',
        rowStepOf: 'Шаг {current} из {total}',
        editRow: 'Изменить',
        cancel: 'Отмена',
        rowsEmpty: 'Строк пока нет. Добавьте первый цвет и размер.',
        addFirstRow: 'Добавить первую строку',
        saveRow: 'Сохранить строку',
        close: 'Закрыть',
        rows: 'Строки цвета и размера',
        history: 'История за день',
        exportXlsx: 'Экспорт XLSX',
        dateFrom: 'Дата с',
        dateTo: 'Дата по',
        dateRange: 'Период',
        date: 'Дата',
        shift: 'Смена',
        allShifts: 'Все смены',
        day: 'Дневная',
        night: 'Ночная',
        product: 'Модель',
        allProducts: 'Все модели',
        warehouse: 'Склад полуфабрикатов',
        allWarehouses: 'Все склады',
        employee: 'Сотрудник',
        machine: 'Машина',
        order: 'Производственный заказ',
        notes: 'Примечания',
        optional: 'Необязательно',
        noOrder: 'Без заказа',
        selectProduct: 'Выберите модель',
        selectWarehouse: 'Выберите склад',
        color: 'Цвет',
        selectColor: 'Выберите цвет',
        pick: 'Выбрать',
        generate: 'Создать',
        colorPickerTitle: 'Выберите цвет',
        colorPickerEyebrow: 'Справочник цветов',
        colorSearch: 'Поиск цветов',
        colorSearchPlaceholder: 'Название или код',
        noColors: 'Подходящие цвета не найдены.',
        noColorCode: 'Без кода',
        colorPage: '{count} поз. · Страница {page} из {total}',
        closeColorPicker: 'Закрыть выбор цвета',
        modelPickerTitle: 'Выберите модель',
        modelPickerEyebrow: 'Каталог моделей',
        modelSearch: 'Поиск моделей',
        modelSearchPlaceholder: 'Название или SKU',
        noModels: 'Подходящие модели не найдены.',
        modelPage: '{count} поз. · Страница {page} из {total}',
        closeModelPicker: 'Закрыть выбор модели',
        modelLoading: 'Загрузка моделей...',
        clearModel: 'Сбросить фильтр модели',
        size: 'Размер',
        sizePlaceholder: 'Введите или выберите',
        sizeSuggestions: 'Рекомендуемые размеры',
        quantity: 'Количество',
        lotNumber: 'Номер партии',
        basket: 'Корзина',
        lotWarehouse: 'Партия / склад',
        worker: 'Работник',
        rowNotes: 'Примечание строки',
        actions: 'Действия',
        search: 'Поиск',
        searchPlaceholder: 'Модель, цвет, размер или склад',
        perPage: 'На странице',
        showDeleted: 'Показывать удалённые',
        applyFilters: 'Применить',
        status: 'Статус',
        active: 'Активная',
        deleted: 'Удалена',
        deleteBatch: 'Удалить партию',
        deleting: 'Удаление...',
        deleteConfirm: 'Удалить эту производственную партию?',
        deleteSuccess: 'Производственная партия удалена.',
        pageOf: 'Страница {page} из {total} · строк: {count}',
        addRow: 'Добавить строку',
        remove: 'Удалить',
        totalQuantity: 'Общее количество',
        rowCount: 'Строки',
        pageTotal: 'Итого по странице',
        filteredTotal: 'Итого по фильтру',
        clear: 'Очистить',
        submit: 'Оприходовать',
        submitting: 'Сохранение...',
        validation: 'Выберите модель, склад полуфабрикатов и заполните каждую строку.',
        saved: 'Сохранено строк вязки: {count}.',
        loading: 'Загрузка выработки вязки...',
        empty: 'За эту дату выработка вязки не записана.',
      },
      orderDetail: {
        backToOrders: 'К заказам',
        title: 'Производственный заказ',
        planned: 'План',
        produced: 'Произведено',
        totalLots: 'Всего партий',
        activeLots: 'Активных партий',
        completedLots: 'Завершённых партий',
        stageProgress: 'Прогресс этапов',
        cancel: 'Отмена',
        createLot: 'Создать партию',
        creating: 'Создание…',
        startingStage: 'Начальный этап',
        quantity: 'Количество',
        notes: 'Примечания',
        colorVariants: 'Цветовые варианты',
        addColor: 'Добавить цвет',
        removeColor: 'Удалить',
        colorName: 'Цвет',
        colorQuantity: 'Кол-во',
        colorSummary: 'Цвета',
        colorsSumHint: 'Сумма {sum} из {quantity}',
        colorRequired: 'Укажите название цвета и положительное количество в каждой строке.',
        colorSumError: 'Сумма по цветам должна равняться количеству партии.',
        lotCreated: 'Партия {lot} создана.',
        noStages: 'Для этого заказа этапы не настроены.',
        lotQueue: 'Очередь партий',
        lotNumber: 'Номер партии',
        allStatuses: 'Все статусы',
        allStages: 'Все этапы',
        active: 'Активна',
        completed: 'Завершена',
        cancelled: 'Отменена',
        lotStatuses: {
          active: 'Активна',
          completed: 'Завершена',
          cancelled: 'Отменена',
        },
        stageStatuses: {
          pending: 'Ожидает',
          in_progress: 'В работе',
          closed: 'Закрыт',
          completed: 'Завершён',
        },
        noLotsMatch: 'Нет партий, соответствующих фильтрам.',
        lot: 'Партия',
        status: 'Статус',
        currentStage: 'Текущий этап',
        initial: 'Начальное',
        current: 'Текущее',
        created: 'Создано',
        actions: 'Действия',
        progress: 'Прогресс',
        closeStage: 'Закрыть этап',
        recordProgress: 'Записать прогресс',
        stageLabel: 'Этап:',
        completedQty: 'Выполнено',
        rejected: 'Брак',
        rework: 'Переработка',
        employeeId: 'ID сотрудника',
        employee: 'Сотрудник',
        unassigned: 'Не назначен',
        selectEmployeePlaceholder: 'Выберите сотрудника',
        details: 'Подробнее',
        viewEntries: 'Записи',
        reopenStage: 'Переоткрыть',
        closeStageTitle: 'Закрыть этап',
        closeStageHint: 'Закрывает этот этап по всему заказу (все партии).',
        confirm: 'Подтвердить',
        close: 'Закрыть',
        reopenStageTitle: 'Переоткрыть этап',
        reopenHint: 'Переоткрытие требует указания причины и прав руководителя.',
        reopenReason: 'Причина',
        selectReason: 'Выберите причину…',
        reopenReasonText: 'Описание причины',
        reopenRequiresReason: 'Выберите причину и укажите описание.',
        stageClosedAll: 'Этап {stage} закрыт для всех партий.',
        stageReopened: 'Этап {stage} переоткрыт.',
        entriesTitle: 'Записи этапа',
        noEntries: 'Для этого этапа записи не зарегистрированы.',
        entryAction: 'Действие',
        entryDeltas: 'Изменения',
        entryEmployee: 'Сотрудник',
        entryLot: 'Партия',
        entryTime: 'Время',
        entryStage: 'Этап',
        entryTypes: {
          progress: 'Прогресс',
          close: 'Закрытие',
          reopen: 'Переоткрытие',
          create: 'Создание',
        },
        reopenReasons: {
          qc_issue: 'Проблема контроля качества',
          operator_error: 'Ошибка оператора',
          material_issue: 'Проблема с материалом',
          machine_issue: 'Проблема с оборудованием',
          supervisor_decision: 'Решение руководителя',
          other: 'Другое',
        },
        lotDetailsTitle: 'Детали партии',
        lotStages: 'Отслеживание этапов партии',
        lotEntries: 'Активность партии',
        stage: 'Этап',
        save: 'Сохранить',
        selectEmployee: 'Выберите отчитывающегося сотрудника.',
        selectClosingEmployee: 'Выберите сотрудника, закрывающего этап.',
        closeConfirm: 'Закрыть этап {stage} для партии {lot}?',
        progressRecorded: 'Прогресс записан для партии {lot}.',
        stageClosed: 'Этап закрыт для партии {lot}.',
        enterStageQuantity: 'Введите начальный этап и количество больше нуля.',
        loadingOrder: 'Загрузка заказа…',
        pageOf: 'Страница {page} из {total}',
        previous: 'Назад',
        next: 'Вперёд',
      },
      downtime: {
        eyebrow: 'Учёт простоев',
        title: 'События простоя',
        description: 'Зарегистрированные простои с причинами и длительностью.',
        reason: 'Причина',
        machine: 'Машина',
        noMachine: 'Без оборудования',
        selectMachine: 'Выберите оборудование…',
        reasons: {
          machine_breakdown: 'Поломка оборудования',
          setup_change: 'Переналадка / смена размера',
          yarn_shortage: 'Нехватка пряжи',
          power_outage: 'Отключение электроэнергии',
          no_assignment: 'Не назначен оператор',
          qc_wait: 'Ожидание ОТК',
        },
        start: 'Начало',
        end: 'Конец',
        duration: 'Длительность',
        minutes: '{count} мин',
        reportedBy: 'Сообщил',
        loading: 'Загрузка простоев…',
        empty: 'Простои не зарегистрированы.',
        totalDowntime: 'Общий простой',
        activeDowntime: 'Активный простой',
        noActiveDowntime: 'Нет активных простоев.',
        ongoing: 'В процессе',
        openDowntime: 'Зарегистрировать простой',
        close: 'Закрыть',
        closeConfirm: 'Закрыть этот простой?',
        selectReason: 'Выберите причину',
        machineId: 'ID машины',
        startTime: 'Время начала',
        endTime: 'Время окончания',
        report: 'Зарегистрировать',
        reporting: 'Регистрация…',
        openOnly: 'Только открытые',
        reported: 'Простой #{id} зарегистрирован',
        closed: 'Простой #{id} закрыт',
      },
      handover: {
        eyebrow: 'Управление сменами',
        title: 'Передача смены',
        description: 'Записи о передаче смен и примечания руководителя.',
        shift: 'Смена',
        from: 'С',
        to: 'По',
        supervisor: 'Руководитель',
        notes: 'Примечания',
        summary: 'Сводка',
        ordersHandedOver: 'Передано заказов',
        issuesFlagged: 'Отмеченные проблемы',
        loading: 'Загрузка записей передачи смен…',
        empty: 'Нет записей передачи смен за выбранный период.',
        attentionRequired: 'Требуется внимание',
        printSnapshot: 'Печать сводки',
        exportCsv: 'Экспорт CSV',
        createHandover: 'Создать передачу смены',
        create: 'Создать',
        creating: 'Создание…',
        save: 'Сохранить',
        cancel: 'Отмена',
        created: 'Передача смены #{id} создана',
      },
      knittingKiosk: {
        description: 'Сканирование карты, выработка корзины и этикетка партии для этапа вязки.',
        stepScan: 'Отсканируйте карту, чтобы создать новую запись',
        stepPick: 'Выберите производственный заказ',
        stepEnter: 'Введите количество выработки',
        stepEnterHint: 'Заполните ячейки цвета и размера, затем нажмите «Сохранить выработку».',
        stepSaved: 'Выработка сохранена — напишите номер корзины на этикетке',
        stepSavedHint: 'Нажмите «Вернуться к заказам», чтобы создать следующую корзину — работник остаётся в системе.',
        resultDone: 'Готово — сканируйте следующую карту',
        resultBackToOrders: 'Вернуться к заказам',
        setupOpen: 'Настройка терминала',
        backToShopfloor: 'Вернуться на участок',
        setupTitle: 'Настройка терминала',
        setupDescription: 'Хранится только на этом устройстве и настраивается один раз для киоска.',
        stageCode: 'Коды этапов',
        stageCodeHint: 'Оставьте пустым — коды этапов этого терминала определятся по открытым производственным заказам (рекомендуется). Список через запятую переопределяет автоопределение.',
        stageCodePlaceholder: 'Авто',
        stageDetected: 'Определено по открытым заказам: {stages}',
        stageNone: 'пока ничего не найдено',
        token: 'Токен терминала',
        tokenHint: 'Токен устройства этого киоска. Сканирование карты подтверждается им, а не сессией оператора.',
        idleTimeout: 'Таймер выхода (секунды)',
        idleTimeoutHint: 'Бездействие до автоматического выхода работника ({min}–{max} с). Экран корзины сам не выключает — возвращает к списку заказов.',
        warehouse: 'Склад-получатель',
        warehouseEmpty: 'Склад полуфабрикатов не найден. Попросите руководителя настроить его.',
        close: 'Закрыть',
        loginSubtitle: 'Приложите рабочую карту к считывателю — нажимать на поле не нужно.',
        cardLabel: 'Номер карты',
        cardPlaceholder: 'Ожидание карты…',
        loginSubmit: 'Продолжить',
        loginChecking: 'Проверка карты…',
        loginFailed: 'Карта не распознана. Попробуйте снова или введите код сотрудника.',
        tokenRejected: 'Токен терминала отклонён. Проверьте его в настройке терминала или введите код сотрудника.',
        codeLabel: 'Код сотрудника',
        codePlaceholder: 'Например EMP-0012',
        codeSubmit: 'Продолжить',
        codeFailed: 'Активный производственный сотрудник с таким кодом не найден.',
        codeToggle: 'Нет карты? Введите код сотрудника',
        needPermission: 'Ваша учётная запись не может вводить выработку. Обратитесь к руководителю.',
        shift: 'Смена',
        shiftDay: 'Дневная',
        shiftNight: 'Ночная',
        changeWorker: 'Сменить работника',
        sessionTimeout: 'Автовыход через {time}',
        fullscreenEnter: 'Полный экран',
        fullscreenExit: 'Выйти из полноэкранного режима',
        journal: 'Журнал',
        journalTitle: 'Корзины — последние 24 часа',
        journalSubtitle: 'Сохранённые корзины со всех терминалов.',
        journalMine: 'Мои корзины',
        journalAll: 'Все терминалы',
        journalSummary: '{baskets} корзин · {quantity} пар',
        journalEmpty: 'За последние 24 часа корзины не сохранены.',
        journalOffline: 'Сервер недоступен — показаны только корзины, сохранённые этим терминалом.',
        journalTime: 'Время',
        journalProduct: 'Продукт',
        journalWorker: 'Работник',
        journalLines: 'Цвет / размер',
        journalStatus: 'Статус',
        journalQuantity: 'Выработка',
        journalPage: '{count} корзин · страница {page} из {total}',
        journalClose: 'Закрыть журнал',
        productsSubtitle: 'Показаны только продукты, ожидающие на этом этапе.',
        productsSearch: 'Поиск по названию продукта',
        productsRefresh: 'Обновить',
        productsEmpty: 'Сейчас на этом этапе ничего не ожидает.',
        productsEmptyHint: 'Коды этапов: {stages}. Продукт появляется здесь, только если у открытого заказа на первой операции остался остаток в матрице цвет/размер.',
        productsNoMatch: 'Нет продуктов по запросу.',
        productsRemaining: 'Остаток',
        productsCells: '{count} цвет/размер',
        matrixSize: 'Размер',
        matrixPlan: 'План',
        matrixLeft: 'Остаток',
        matrixScrollLeft: 'Прокрутить цвета влево',
        matrixScrollRight: 'Прокрутить цвета вправо',
        matrixQuantity: 'Выработка',
        matrixClear: 'Очистить',
        matrixTotal: 'Итого выработка',
        matrixSave: 'Сохранить выработку',
        matrixSaving: 'Сохранение…',
        matrixEmpty: 'Сначала введите количество выработки.',
        matrixMax: 'Для этого размера осталось только {max} пар.',
        numpadOpen: 'Цифровая клавиатура',
        numpadClose: 'Готово',
        numpadBack: 'Удалить символ',
        matrixNoWarehouse: 'Склад-получатель не настроен. Откройте настройку терминала.',
        matrixNoColour: 'Без цвета',
        matrixNoSize: 'Без размера',
        back: 'Назад',
        resultBasket: 'Номер корзины',
        resultQuantity: 'Выработка',
        resultPrint: 'Печать этикетки',
        pendingTitle: 'Ожидают отправки',
        pendingHint: 'Записей выработки в очереди: {count}. Они сохранены на устройстве — повторите при появлении сети.',
        pendingRetry: 'Повторить',
        pendingCancel: 'Отменить эту выработку',
        pendingCancelConfirm: 'Удалить неотправленную выработку? На сервере она не сохранена и восстановить её нельзя.',
        pendingNeedsReview: 'Сервер отклонил — повторите после исправления или отмените',
        pendingWaiting: 'Ожидает отправки',
        pendingRows: '{count} строк цвет/размер',
        pendingFailed: 'Часть записей не удалось сохранить',
      },
      pagination: {
        of: 'из',
        previous: 'Назад',
        next: 'Вперёд',
      },
      state: {
        loading: 'Загрузка…',
        error: 'Что-то пошло не так.',
        retry: 'Повторить',
        noData: 'Нет данных.',
      },
    },
  },
}

Object.assign(shopfloorMessages.en.shopfloor.orderDetail, {
  recordOutput: 'Record production output',
  simplifiedPlan: 'Simplified production order',
  variantPlan: 'Color and size plan',
  variantPlanTotal: '{count} total units',
  size: 'Size',
})
Object.assign(shopfloorMessages.en.shopfloor.knittingOutput, {
  loadingOrderPlan: 'Loading order color/size plan...',
  orderPlanLoaded: '{count} planned color/size combinations loaded',
  plannedForVariant: 'Planned: {count}',
  matrixInputHint: 'Enter the newly finished quantity for each planned color and size.',
  finishedPlanned: 'Finished {finished} / Planned {planned}',
  outputQuantity: 'Output quantity',
})

Object.assign(shopfloorMessages.uz.shopfloor.orderDetail, {
  recordOutput: 'Ishlab chiqarish natijasini kiritish',
  simplifiedPlan: 'Soddalashtirilgan ishlab chiqarish buyurtmasi',
  variantPlan: 'Rang va o‘lcham rejasi',
  variantPlanTotal: 'Jami {count} dona',
  size: 'O‘lcham',
})
Object.assign(shopfloorMessages.uz.shopfloor.knittingOutput, {
  loadingOrderPlan: 'Buyurtmaning rang/o‘lcham rejasi yuklanmoqda...',
  orderPlanLoaded: '{count} ta rejalashtirilgan rang/o‘lcham birikmasi yuklandi',
  plannedForVariant: 'Reja: {count}',
  matrixInputHint: 'Har bir rejalashtirilgan rang va o‘lcham uchun yangi tayyor miqdorni kiriting.',
  finishedPlanned: 'Tayyor {finished} / Reja {planned}',
  outputQuantity: 'Ishlab chiqarilgan miqdor',
})

Object.assign(shopfloorMessages.ru.shopfloor.orderDetail, {
  recordOutput: 'Внести результат производства',
  simplifiedPlan: 'Упрощённый производственный заказ',
  variantPlan: 'План цветов и размеров',
  variantPlanTotal: 'Всего {count} единиц',
  size: 'Размер',
})
Object.assign(shopfloorMessages.ru.shopfloor.knittingOutput, {
  loadingOrderPlan: 'Загрузка плана цветов и размеров заказа...',
  orderPlanLoaded: 'Загружено сочетаний цвета и размера: {count}',
  plannedForVariant: 'План: {count}',
  matrixInputHint: 'Введите новое готовое количество для каждого запланированного цвета и размера.',
  finishedPlanned: 'Готово {finished} / План {planned}',
  outputQuantity: 'Выпущенное количество',
})
